import { Component, OnInit, Type, ViewChild } from "@angular/core";
import * as moment from 'moment';
import { ProjectCostService } from '../../services/project-cost.service';
import { DropDownList } from '../../models/DropDownList.model';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { ConsultantService } from '../../services/consultant.service';
import { Consultant } from '../../models/Consultant.model';
import { ConsultantSearch } from '../../models/ConsultantSearch.model';
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { CompanyService } from '../../services/billing-letter/company.service';
import { Company } from '../../models/Company.model';
import  *  as _ from "lodash";
import { ApprovalsSearchFactory } from '../../shared/factories/approvals/ApprovalsSearch.factory';
import { ProjectFinancialService } from '../../services/projectFinancial.service';
import { OptionsBilling } from "../../shared/enums/billing-letter/OptionsBilling";
import { Json2csvService } from "../../services/json2csv.service";
import { UtilsProjectCost } from "./utils";
import { FilterBuilder } from "../../shared/builders/filter.builder";
@Component({
    selector: "app-projects-cost",
    templateUrl: "./projects-cost.component.html",
    styleUrls: ["./projects-cost.component.css"],
})
export class ProjectsCostComponent implements OnInit {
    projections: any;
    projectionsExport: any;
    currentPage: number = 1;
    totalItems: number = 0;
    itemsPerPage: number[] = [5, 10, 50, 100];
    yearList;

    dropDownListConsultants: DropDownList[] = new Array<DropDownList>();
    dropDownListProjects: DropDownList[] = new Array<DropDownList>();
    dropDownListCompanies: DropDownList[] = new Array<DropDownList>();
    dropDownListCompanyGroups: DropDownList[] = new Array<DropDownList>();
    dropDownListMonths: DropDownList[] = new Array<DropDownList>();
    dropDownListYears: DropDownList[] = new Array<DropDownList>();
    dropDownListSubDivisions: DropDownList[] = new Array<DropDownList>();


    selectedConsultantsItems: DropDownList[] = new Array<DropDownList>();
    selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
    selectedProjectsItems: DropDownList[] = new Array<DropDownList>();
    selectedResponsibleItems: DropDownList[] = new Array<DropDownList>();
    selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
    selectedCompanyMonthsItems: DropDownList[] = new Array<DropDownList>();
    selectedCompanyYearsItems: DropDownList[] = new Array<DropDownList>();
    selectedSubDivisionsItems: DropDownList[] = new Array<DropDownList>();


    dropDownConsultantsSettings = {};
    dropDownProjectsSettings = {};
    dropDownCompaniesSettings = {};
    dropDownCompanyGroupsSettings = {};
    dropDownMonthsSettings = {};
    dropDownYearsSettings = {};
    dropDownSubDivisionsSettings = {};


    loading: boolean;
    commonHelper: CommonHelper = new CommonHelper();
    consultants: Consultant[] = new Array<Consultant>();
    approvalsSearch;
    approvalSearchFactory = new ApprovalsSearchFactory();
    companyGroups: Array<any> = [];
    companies: Company[] = new Array<Company>();
    projects: Array<any> = [];
    months: Array<any> = [];
    allSubDivisions;

    constructor(
        private projectCostService: ProjectCostService,
        private consultantService: ConsultantService,
        private LocalStorage: LocalStorage,
        private companyGroupService: CompanyService,
        private projectsFinancialService: ProjectFinancialService,
        private filterBuilder: FilterBuilder,
        private optionsBilling: OptionsBilling,
        private Json2csvService: Json2csvService,
        private utilsProjectCost: UtilsProjectCost
    ) {}

    async ngOnInit() {
        this.loading = true;
        this.months = this.commonHelper.multiSelectMonths();
        this.yearList = this.commonHelper.listLastYears();
        this.allSubDivisions = await this.projectsFinancialService.getAllSubDivisions();
        this.yearList  = this.yearList.map(date => {
            return {
                _id: date,
                name: date
            }
        })

        if (this.LocalStorage.retrieve("projection-cost"))
            this.setFilters();



        let consultantSearch = new ConsultantSearch();
        consultantSearch.onlyActives = true;
        consultantSearch.limit = 9999999;
        consultantSearch.fields = ["_id", "name","active"];

        this.consultants = await this.consultantService.searchConsultants(consultantSearch);

        this.companyGroups = await this.companyGroupService.getAllCompanyGroups();

        let response = await this.projectsFinancialService.getProjectsAndCustomers();
        this.approvalsSearch = this.approvalSearchFactory.newSearch();
        this.companies = response.customers;
        this.companies = _.sortBy(this.companies,"name");

        this.projects = response.projects;


        this.dropDownListConsultants = this.commonHelper.getDropDownListConsultant(this.consultants, "_id", "name",null,null,"active");
        this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
        this.dropDownListCompanies = this.commonHelper.getDropDownListItems(this.companies, "_id", "name");
        this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects, "_id", "name");
        this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
        this.dropDownListMonths = this.commonHelper.getDropDownListItems(this.months, "_id", "name");
        this.dropDownListYears = this.commonHelper.getDropDownListItems(this.yearList, "_id", "name");

        this.dropDownConsultantsSettings = this.commonHelper.getDropDownSettings(false, 'Consultores', false, 'Marcar todos os consultores', 'Desmarcar todos os consultores', true,'active','');
        this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(false, 'Grupo de empresa', false, 'Marcar todos os grupos', 'Desmarcar todos os grupos', true,null, '');
        this.dropDownCompaniesSettings = this.commonHelper.getDropDownSettings(false, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true,null, '');
        this.dropDownProjectsSettings = this.commonHelper.getDropDownSettings(false, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true,null, '');
        this.dropDownMonthsSettings = this.commonHelper.getDropDownSettings(false, "Meses", true, "Marcar todos os meses", "Desmarcar todos os meses", true, null, "");
        this.dropDownYearsSettings = this.commonHelper.getDropDownSettings(false, "Anos", true, "Marcar todos os anos", "Desmarcar todos os anos", true, null, "");
        this.dropDownSubDivisionsSettings = this.commonHelper.getDropDownSettings(false, 'Tipos de Serviços', false, 'Marcar todos os Tipos de Serviços', 'Desmarcar todos os Tipos de Serviços', true,null, '');

        this.allSubDivisions = await this.filterBuilder.buildSubDivisionFilter()
        this.dropDownListSubDivisions = this.allSubDivisions;
        await this.search();
        this.loading = false;

    }

    async handlePage(page){
        if(page != this.currentPage){
            this.currentPage = page;
            await this.search();
        }
    }

    onChange() {
        this.LocalStorage.persist("projection-cost", {
            selectedConsultantsItems:this.selectedConsultantsItems,
            selectedCompaniesItems: this.selectedCompaniesItems,
            selectedProjectsItems: this.selectedProjectsItems,
            selectedCompanyGroupsItems: this.selectedCompanyGroupsItems,
            selectedCompanyMonthsItems: this.selectedCompanyMonthsItems,
            selectedCompanyYearsItems: this.selectedCompanyYearsItems,
            selectedSubDivisionsItems: this.selectedSubDivisionsItems,
        });
    }

    async search(page?: number, exportProjetions?: boolean) {
        this.loading = true;
        let pageAux = page ? page : this.currentPage;
        this.approvalsSearch.skip = (pageAux - 1) * this.approvalsSearch.limit

        this.approvalsSearch.consultants = [];
        this.approvalsSearch.projects = [];
        this.approvalsSearch.groups = [];
        this.approvalsSearch.companies = [];
        this.approvalsSearch.subDivisions = [];
        this.approvalsSearch.companyGroups = [];
        this.approvalsSearch.months = [];
        this.approvalsSearch.years = [];

        for (let c of this.selectedConsultantsItems)
            this.approvalsSearch.consultants.push(c.id);

        for (let p of this.selectedProjectsItems)
            this.approvalsSearch.projects.push(p.id);

        for (let comp of this.selectedCompaniesItems)
            this.approvalsSearch.companies.push(comp.id);

        for (let cg of this.selectedCompanyGroupsItems)
            this.approvalsSearch.companyGroups.push(cg.id);

        for (let cg of this.selectedCompanyMonthsItems)
            this.approvalsSearch.months.push(cg.id);

        for (let cg of this.selectedCompanyYearsItems)
            this.approvalsSearch.years.push(cg.id);

        for (let sub of this.selectedSubDivisionsItems)
        this.approvalsSearch.subDivisions.push(sub.id);

        let projectionsData = await this.projectCostService.getProjectCostAll(this.approvalsSearch);
        if(projectionsData && projectionsData.projections ){
            this.totalItems = projectionsData.totalItems;
            if(!exportProjetions) {
                this.projections = projectionsData.projections.map(project => {
                    let newDate = moment(project.created).format('DD/MM/YYYY');
                    return {...project, dateCreate: newDate};
                });
            } else {
                this.projectionsExport = projectionsData.projections.map(project => {
                    let newDate = moment(project.created).format('DD/MM/YYYY');
                    return {...project, dateCreate: newDate};
                });
            }
        } else {
            this.projections = undefined;
        }

        this.loading = false;
    }

    setFilters(){
        let storage = this.LocalStorage.retrieve("projection-cost");
        if(storage.approvalsSearch)
          this.approvalsSearch = storage.approvalsSearch;
        this.selectedConsultantsItems = storage.selectedConsultantsItems?storage.selectedConsultantsItems:[];
        this.selectedCompaniesItems = storage.selectedCompaniesItems?storage.selectedCompaniesItems:[];
        this.selectedProjectsItems = storage.selectedProjectsItems?storage.selectedProjectsItems:[];
        this.selectedResponsibleItems = storage.selectedResponsibleItems?storage.selectedResponsibleItems:[];
        this.selectedCompanyGroupsItems = storage.selectedCompanyGroupsItems?storage.selectedCompanyGroupsItems:[];
        this.selectedSubDivisionsItems = storage.selectedSubDivisionsItems?storage.selectedSubDivisionsItems:[];
    }

    async export() {
        let limitAux = this.approvalsSearch.limit;
        this.approvalsSearch.limit = 999999999999;
        await this.search(1, true);
        let newCSV = [];
        let newProjections = this.projectionsExport.map(projection => {
            projection.consultants.map((consultant) => {
                consultant.competences = consultant.competences.filter(date => {
                    if(this.approvalsSearch.months.length == 0 && this.approvalsSearch.years.length == 0)
                        return date;
                    else
                        if(this.approvalsSearch.months.length > 0 && this.approvalsSearch.years.length > 0)
                            return this.approvalsSearch.months.includes((date.month).toString()) && this.approvalsSearch.years.includes(date.year);
                        else {
                            if(this.approvalsSearch.months.length > 0 )
                                return this.approvalsSearch.months.includes((date.month).toString());

                            if(this.approvalsSearch.years.length > 0)
                                return this.approvalsSearch.years.includes(date.year);
                        }
                });
                return consultant;
            });
            return projection;
        });

        newProjections.map(projection => {
            projection.consultants.map((consultant) => {
              consultant.competences.map(date => {
                let newDate = this.utilsProjectCost.multiSelectMonthsAndYears(`${date.month}/${date.year}`);
                newCSV.push({
                  "Consultores":          consultant.name ? consultant.name : '-',
                  "Tipo de Contrato":     consultant.kind ? this.commonHelper.transcriptContractType(consultant.kind) : '-',
                  "Honorario":            consultant.honorarium ? this.commonHelper.transcriptHonorariumType(consultant.honorarium) : '-',
                  "Cliente":              projection.customer.name ? projection.customer.name : '-',
                  "Grupo de Empresa":     projection.companyGroup.name ? projection.companyGroup.name : '-',
                  "Projeto":              projection.project.name ? projection.project.name : '-',
                  "Tipos de Serviços":    projection.project.subDivision ?  projection.project.subDivision.name : '-',
                  "Horas Estimadas":      consultant.estimatedHours ? consultant.estimatedHours : '-',
                  "Valor Total Hora":     consultant.hourValue ? consultant.hourValue.toFixed(2) : '-',
                  "Competência":          newDate ? newDate.name.slice(0, -5) : '-',
                  "Ano":                  newDate ? newDate.name.slice(-4) : '-',
                  "Projeção de Custos":   consultant.projectCost ? consultant.projectCost.toFixed(2) : '-',
                });
              });
            });
        });
        this.Json2csvService.export(newCSV, `Projeção - ${new Date().toLocaleDateString('pt-br')}`);
        this.approvalsSearch.limit = limitAux;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/project-cost/projects-cost.component.ts